var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-button"},[_c('v-btn',{staticClass:"p-2 font-weight-bold",attrs:{"rounded":"","color":"primary","elevation":"4"},on:{"click":_vm.startInstallationProcess}},[_c('v-icon',{staticClass:"white--text",attrs:{"size":"24"}},[_vm._v("$plus")]),_vm._v(" "+_vm._s(_vm.$t('button.instance.add'))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }